/*
 * Copyright (c) 2021
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import { ContentResponse } from '../model';


@Injectable()
export class ResearchContentService {
  public researchContent = new BehaviorSubject<ContentResponse>(null);
  public researchContent$ = this.researchContent.asObservable();


  private researchLoading = new BehaviorSubject<boolean>(false);
  researchLoading$ = this.researchLoading.asObservable();


  public setContent(content: ContentResponse): void {
    this.researchContent.next(content);
  }

  public clearContent(): void {
    this.researchContent.next(null);
  }

  public setLoading(isLoading: boolean): void {
    this.researchLoading.next(isLoading);
  }


}
